import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class shippingItems extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Shipping Items </h2>

                <br/>
               

                <h6> How to ship an item: </h6>
                
                <div style={{padding:'75% 0 0 0', position:'relative'}}>
                <iframe src="https://player.vimeo.com/video/764170646?h=c190db33e9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" 
                allow="autoplay; fullscreen; picture-in-picture" 
                allowFullScreen style={{position:'absolute', top:0, left:0,width:'100%',height:'100%'}} 
                title="Shipping Wizard Tutorial"></iframe>
                </div><script src="https://player.vimeo.com/api/player.js"></script>
                 
                
            </div>
        )
       


    }

}
export default withRouter(shippingItems);
